import React from 'react'
import Select from 'react-select'
import { Col, Row } from 'react-bootstrap'
import { getMultiselectorOptions } from './helpers'

const FormMultiselector = ({ column, index, columnsValues, handleColumnChange }) => {
    const isInventoryTypeHomepage = columnsValues['inventory_type']?.value === 3
    const isInventoryTypeEmail = columnsValues['inventory_type']?.value === 35

    return (
        <div className="setting-item" key={index}>
            <Row className="g-2 align-items-center">
                <Col md="3">
                    <h6>{column.title}</h6>
                    <p>{column.is_required && 'Required'}</p>
                </Col>
                <Col md>
                    {column.name === 'related_categories_ids' && (isInventoryTypeHomepage || isInventoryTypeEmail) ? (
                        <Select
                            id="basic-select-single"
                            value={{ label: 'All categories', value: 'All categories are associated to inventory by default' }}
                            isDisabled={true}
                        />
                    ) : (
                        <Select
                            disabled={column.is_disabled}
                            id="basic-typeahead-single"
                            onChange={e => handleColumnChange(e, column)}
                            options={getMultiselectorOptions(column, [6,7, 8, 9].includes(columnsValues['inventory_type']?.value))}
                            isSearchable={true}
                            placeholder={column.placeholder}
                            value={columnsValues[column.name]}
                            defaultValue={columnsValues[column.name]}
                            isMulti
                        />
                    )}
                    {column.name === 'related_categories_ids' && (isInventoryTypeHomepage || isInventoryTypeEmail) ? (
                        <div className="d-flex align-items-center fs-xs text-secondary mb-0 mt-1">
                            <i className="ri-information-line me-1"></i>
                            All categories are associated to this inventory type by default
                        </div>
                    ) : null}
                </Col>
            </Row>
        </div>
    )
}

export default FormMultiselector
